module.exports = __webpack_public_path__ + "img/icon-btn-android2.830b5328.png";